<template>
  <b-container>
    <b-row>
      <b-col md="12">
        <div class="service-banner mb-5">
          <font-awesome-icon
              :icon="['fas', icon]"
              size="3x"
          ></font-awesome-icon>
          <p>{{ category }}</p>
          <h2>{{ name }}</h2>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        {{ slug }}
      </b-col>
      <b-col md="3" offset="3">
        <div class="sidebar">
          <div class="sidebar sidebar__menu mb-5">
            <div class="sidebar sidebar__menu-title">
              <h4>Explore our services</h4>
            </div>
            <div class="sidebar sidebar__menu-links">
              <ul v-for="service in services">
                <li>
                  {{ service.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="sidebar sidebar__form">
            <consultation-form></consultation-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConsultationForm from "@/components/ConsultationForm";

export default {
  name: "SingleService",
  data() {
    return {
      //
    }
  },
  components: {
    ConsultationForm
  },
  props: [
      'slug',
      'name',
      'category',
      'icon',
      'services'
  ],
}
</script>

<style lang="scss" scoped>
.service-banner {
  background: $dark-blue;
  border-radius: 10px;
  padding: 50px 25px;

  h2, p {
    color: $white;
    margin: 0;
  }

  h2 {
    font-weight: 500;
  }

  p {
    color: $dark-grey;
  }

  svg {
    color: $light-blue;
    margin: 0 0 15px 0;
  }
}

.sidebar {
  &__menu {
    h4 {
      margin-bottom: 25px;
      padding: 0 0 15px 0;
      font-weight: 500;
      border-bottom: 2px dashed $dark-grey;
    }
    ul {
      padding: 0;
      li {
        display: flex;
        color: $dark-blue;
        font-size: 16px;
        font-weight: 500;
        flex-direction: row;
        align-items: center;
        margin-bottom: 15px;
        list-style-type: none;
        &:before {
          content: "";
          margin-right: 2rem;
          background: $dark-blue;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: inline-grid;
          place-items: center;
          line-height: 1.2em;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}

</style>